import type { BanDich } from '../../types';
import type { viRpaChung } from './chung.vi';

export const enRpaChung: Pick<BanDich, keyof typeof viRpaChung> = {
  rpa: {
    nhom: 'RPA management',
    khongCoQuyenTieuDe: 'You cannot view this screen yet',
    khongCoQuyenMoTa: 'Requires the {{quyen}} permission. Ask your organisation admin to grant it if you need this screen.',
    chuaKhaiTieuDe: 'OpenCore is not connected',
    moKetNoi: 'Open OpenCore connection',
    nhoQuanTri: 'Ask someone who can configure the OpenCore connection to enter your organisation’s address and service JWT.',
    chuaSanSangTieuDe: 'The RPA module is not ready',
    chuaSanSangMoTa: 'This module is not running on the server yet. Try again in a few minutes; if it persists, contact operations.',
    loiTai: 'Could not load RPA data',
    dangBat: 'On',
    dangTat: 'Off',
  },
  rpaCauHinh: {
    tieuDe: 'Error handling & notifications',
    moTa: 'Set how robots handle each error type, how the server sends notifications (per project) and your organisation’s OpenCore connection.',
    tabLoi: 'Error handling',
    tabThongBao: 'Notifications',
    tabTaiKhoanGui: 'Sender accounts',
    tabKetNoi: 'OpenCore connection',
  },
};
